import * as PIXI from 'pixi.js';
import GlobalDispatcher from "../../events/GlobalDispatcher";
//import PixiSoundSpriteLoader from "./PixiSoundSpriteLoader";
import EntryPoint from "../../EntryPoint";
import WebFont from "webfontloader";

export default class BasePreloaderController extends PIXI.Container {

    constructor(gameFonts) {
        super();

        //new PixiSoundSpriteLoader();

        this._gameFonts = gameFonts;
        this._compiled = EntryPoint.compiled;
        this._localization = EntryPoint.localization;
        this._mobile = EntryPoint.mobile;
        this._hasServerData = false;
        this._hasResources = false;
        this._canStart = true;

        this.addListeners();
        //this.loadPreLoader();
        this.loadFonts();
    }

    addListeners() {
        GlobalDispatcher.addOnce('model:getServerData', this.onGetServerData, this);
    }

    onGetServerData() {
        this.hasServerData = true;
    }

    loadFonts() {
        if (this._gameFonts && this._gameFonts.length > 0) {
            WebFont.load({
                custom: {
                    families: this._gameFonts,
                    urls: ['./fonts.css']
                },
                active: (event) => {
                    this.loadPreLoader()
                }
            });
        } else {
            this.loadPreLoader();
        }
    }

    loadPreLoader() {
        PIXI.Loader.shared.reset();
        PIXI.Loader.shared.baseUrl = './assets/';

        /*let jsonName = this._mobile ? 'PreloaderMobileAssets' : 'PreloaderAssets';
        jsonName += this._compiled ? 'Compiled' : '';
        jsonName += '.json';
        PIXI.Loader.shared.add('PreloaderAssets', jsonName, 'json');*/

        PIXI.Loader.shared.add('PreloaderAssets', this._compiled ? 'PreloaderAssetsCompiled.json' : 'PreloaderAssets.json', 'json');

        PIXI.Loader.shared.once('complete', this.onLoadingPreloaderComplete, this);
        PIXI.Loader.shared.on('progress', this.onLoadingPreloaderProgress, this);
        PIXI.Loader.shared.on('error', this.onLoadingError, this);
        PIXI.Loader.shared.load();

        //this.onLoadingPreloaderComplete();
    }

    onLoadingPreloaderProgress(data) {
        GlobalDispatcher.dispatch('preloaderController:loadingPreloaderProgress', data.progress);
    }

    onLoadingPreloaderComplete() {
        this.emit('preloaderLoadingComplete');
        GlobalDispatcher.dispatch('preloaderController:loadingPreloaderComplete');
        this.loadGame();
    }

    /*loadAssets() {
        PIXI.Loader.shared.reset();
        PIXI.Loader.shared.baseUrl = './assets/';

        PIXI.Loader.shared.add('GameAssets', this._compiled ? 'GameAssetsCompiled.json' : 'GameAssets.json', 'json');

        if(this._localization) {
            PIXI.Loader.shared.add('./localization/common_' + this._localization + '.json');
        }

        PIXI.Loader.shared.once('complete', this.onLoadingComplete, this);
        PIXI.Loader.shared.on('progress', this.onLoadingUpdate, this);
        PIXI.Loader.shared.on('error', this.onLoadingError, this);
        PIXI.Loader.shared.load();
    }*/

    loadGame() {
        PIXI.Loader.shared.reset();
        PIXI.Loader.shared.baseUrl = './assets/';

        this.addAssets();
        this.addLocalization();

        EntryPoint.PostMessages.reportGameStartLoad();

        PIXI.Loader.shared.once('complete', this.onLoadingComplete, this);
        PIXI.Loader.shared.on('progress', this.onLoadingUpdate, this);
        PIXI.Loader.shared.on('error', this.onLoadingError, this);
        PIXI.Loader.shared.load();
    }

    addAssets() {
        let jsonName = this._mobile ? 'GameMobileAssets' : 'GameAssets';
        jsonName += this._compiled ? 'Compiled' : '';
        jsonName += '.json';

        PIXI.Loader.shared.add('GameAssets', jsonName, 'json');
    }

    addLocalization() {
        if (this._localization) {
            let jsonName = this._mobile ? './gameMobile/localization/' + EntryPoint.localization : './game/localization/' + EntryPoint.localization;
            jsonName += '.json';

            PIXI.Loader.shared.add('Localization', jsonName, 'json');
        }
    }

    onLoadingUpdate(data) {
        let {progress} = data;
        EntryPoint.PostMessages.gameLoadProgress(progress);
        GlobalDispatcher.dispatch('preloaderController:progress', progress);
    }

    onLoadingComplete(event) {
        GlobalDispatcher.dispatch('preloaderController:allResourcesLoaded');
        this.onLoadingUpdate(event);
        this.hasResources = true;
    }

    onLoadingError(event) {
        //console.log(event);
        GlobalDispatcher.dispatch('gameError:preloaderError', event.data);
    }

    allComplete() {
        if (this.hasResources && this.hasServerData && this.canStart) {
            this.startGame();
        }
    }

    startGame() {
        if (this.hasResources && this.hasServerData && this.canStart) {
            EntryPoint.PostMessages.reportGameReady();
            this.emit('gameLoadingComplete');
        }
    }

    get hasServerData() {
        return this._hasServerData;
    }

    set hasServerData(value) {
        this._hasServerData = value;
        this.allComplete();
    }

    get hasResources() {
        return this._hasResources;
    }

    set hasResources(value) {
        this._hasResources = value;
        this.allComplete()
    }

    get canStart() {
        return this._canStart;
    }

    set canStart(value) {
        this._canStart = value;
        this.allComplete()
    }
}
